import { get } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';

import { t } from 'ember-intl';
import PowerSelect from 'ember-power-select/components/power-select';
import { not } from 'ember-truth-helpers';

export default class UiFormFieldSelectRecordComponent extends Component {
  // Services
  @service recordRelationships;

  // Getter and setter
  get searchField() {
    return this.args.searchField ?? 'displayLabel';
  }

  get labelProperty() {
    return this.args.labelProperty ?? 'displayLabel';
  }

  get selected() {
    return this.args.model[this.args.property];
  }

  // Functions
  onChange = (option) => {
    if (this.args.onChange) {
      return this.args.onChange(option);
    }

    let { model, property } = this.args;

    if (model.watchRelationship) {
      model.watchRelationship(property, async () => {
        if (model.set) {
          model.set(property, option);
        } else {
          model[property] = option;
        }
      });
    } else {
      model[property] = option;
    }

    this.args.onShowValidations();
  };

  // Template
  <template>
    <PowerSelect
      @allowClear={{not @isRequired}}
      @disabled={{@isDisabled}}
      @loadingMessage={{t 'ui.form.field.select.loading_message'}}
      @onChange={{this.onChange}}
      @options={{@options}}
      @placeholder={{@placeholder}}
      @renderInPlace={{@renderInPlace}}
      @search={{@onSearch}}
      @searchEnabled={{@isSearchEnabled}}
      @searchField={{this.searchField}}
      @searchMessage={{t 'ui.form.field.select.search_message'}}
      @searchPlaceholder={{t 'ui.form.field.select.search_placeholder'}}
      @selected={{this.selected}}
      as |option|
    >
      {{#if (has-block)}}
        {{yield option this.labelProperty}}
      {{else}}
        {{get option this.labelProperty}}
      {{/if}}
    </PowerSelect>
  </template>
}
